__turbopack_context__.v({
  "cart-quantity-dropdown": "cart-quantity-dropdown-component-module-scss-module__zw2TfG__cart-quantity-dropdown",
});
